import { useQuery } from '@tanstack/react-query';

interface VersionPayload {
  version: string;
  build: string;
}

/** The footer — version comes from the api `/version` endpoint (node-only package stays out of the browser bundle). */
export function Footer() {
  const { data: version } = useQuery({
    queryKey: ['version'],
    queryFn: async (): Promise<VersionPayload> => {
      // version lives at the api ORIGIN root, not under /api/v1
      const res = await fetch('/version');
      if (!res.ok) throw new Error(String(res.status));
      const body = (await res.json()) as { data: VersionPayload };
      return body.data;
    },
    staleTime: Infinity,
    retry: false,
  });

  return (
    <footer className="border-t border-border py-8">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 text-sm text-muted-foreground sm:flex-row">
        <p>© {new Date().getFullYear()} opuschamber — art, code and music.</p>
        <nav aria-label="social" className="flex gap-4">
          {/* settings-driven social links land with the settings page (M5); placeholders keep the old look */}
          <a href="#" aria-label="github" className="hover:text-foreground">github</a>
          <a href="#" aria-label="soundcloud" className="hover:text-foreground">soundcloud</a>
          <a href="#" aria-label="instagram" className="hover:text-foreground">instagram</a>
        </nav>
        <p className="font-mono text-xs opacity-60">{version ? `v${version.version} · ${version.build}` : ''}</p>
      </div>
    </footer>
  );
}
